import type React from "react";

import noop from "lodash/noop";

import { SWReactIcons } from "@similarweb/icons";
import { Dropdown, EllipsisDropdownItem, IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { contextMenuKeys } from "./automationKeys";
import { CONTEXT_MENU_ITEMS, HomeContextMenuOptions, MENU_WIDTH, WRAPPER_ID } from "./config";
import * as SC from "./styles";

export type ContextMenuSchema = {
    onClick: (item: { id: HomeContextMenuOptions }) => void;
    isLoading: boolean;
    isLast: boolean;
    isSubscribed: boolean;
    activationId: string;
    isAlertsAllowed: boolean;
    isGaConnectHidden?: boolean;
};

// TODO can be reworked as single shared component with Menu from Topic.tsx

export const ContextMenu = ({
    onClick,
    isLoading,
    isLast,
    activationId,
    isSubscribed,
    isAlertsAllowed,
    isGaConnectHidden,
}: ContextMenuSchema) => {
    const onMenuClick = (event: React.SyntheticEvent<HTMLDivElement>) => event.stopPropagation();

    return (
        <SC.ContextMenuContainer
            onClick={onMenuClick}
            className="menu-wrapper"
            data-automation={contextMenuKeys.wrapper}
            id={`${WRAPPER_ID}_${activationId}`}
        >
            <Dropdown
                onClick={onClick}
                onToggle={noop}
                dropdownPopupPlacement={isLast ? "top-right" : "bottom-right"}
                autoPlacement
                width={MENU_WIDTH}
                appendTo={`#${WRAPPER_ID}_${activationId}`}
            >
                {[
                    <IconButton
                        key="menuButton"
                        type="flat"
                        iconName="dots-more"
                        isLoading={isLoading}
                    />,
                    ...CONTEXT_MENU_ITEMS.filter(({ id }) => {
                        if (id === HomeContextMenuOptions.Subscribe) {
                            return !isSubscribed && isAlertsAllowed;
                        }

                        if (id === HomeContextMenuOptions.ConnectGa) {
                            return !isGaConnectHidden;
                        }

                        return true;
                    }).map(({ id, title, icon }) => (
                        <EllipsisDropdownItem
                            id={id}
                            key={id}
                            disabled={false}
                            data-automation={contextMenuKeys.item}
                        >
                            <SC.InnerItem>
                                <SC.Icon>
                                    <SWReactIcons
                                        size="sm"
                                        iconName={icon}
                                    />
                                </SC.Icon>

                                <div>{translate(title)}</div>
                            </SC.InnerItem>
                        </EllipsisDropdownItem>
                    )),
                ]}
            </Dropdown>
        </SC.ContextMenuContainer>
    );
};

ContextMenu.displayName = "HomeContextMenu";
